export default __webpack_public_path__ + "static/media/O-039.493dad9d.png";